import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the settings route a "Stores" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/org/stores')({
  staticData: { crumb: 'common:nav.stores' },
  component: Outlet,
});
